import { styles } from './styles'

interface PriceProps {
  discountedPrice?: string
  price: string
}

export function Price({ discountedPrice, price }: PriceProps): JSX.Element {
  return (
    <span css={styles.container}>
      PRICE:&nbsp;
      <span data-testid="productPrice" css={discountedPrice && styles.lineThrough}>
        {parseFloat(price || '').toFixed(2)}
      </span>
      {discountedPrice && (
        <span data-testid="productDiscountedPrice" css={styles.discountedPrice}>
          {parseFloat(discountedPrice || '').toFixed(2)}
        </span>
      )}
    </span>
  )
}
